import { callFetch, header } from "./utils";

const EndPoint = {
  AddTag: (lineId) => `/line/${lineId}/tag`,
};

export function addTag(lineId, { tagName, accessToken }) {
  const uri = EndPoint.AddTag(lineId);
  let settings = {
    method: "POST",
    headers: header,
    body: JSON.stringify({
      tagName,
      accessToken,
    }),
  };
  return callFetch(uri, settings);
}
